exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-5f92a1a4].el-button--default{color:#fff!important}", ""]);

// exports
